import PropTypes from 'prop-types';
import React from 'react';
const OptionActionsButtonSelectToggle = ({
  allowsMultipleSelection,
  setOptionsToSelect,
  usableOptions
}) => {
  // only show the "Select All/None" toggle if we allow multiple selections
  if (allowsMultipleSelection && usableOptions.length > 0) {
    const leafOptions = usableOptions.filter(option => !option.hasChildren);
    // and only show the toggle if there are options without children ("leaves") available
    if (leafOptions && leafOptions.length > 0) {
      // eslint-disable-next-line no-underscore-dangle
      const selectedOptions = leafOptions.filter(option => option._isSelected);
      const allOptionsAreSelected = leafOptions.length === selectedOptions.length;
      const handleSelect = () => {
        let optionsForOperation = selectedOptions;
        if (!allOptionsAreSelected) {
          // eslint-disable-next-line no-underscore-dangle
          optionsForOperation = leafOptions.filter(option => !option._isSelected);
        }
        // queue the newly selected or deselected options for `_isSelected` state change
        setOptionsToSelect(optionsForOperation);
      };
      return /*#__PURE__*/React.createElement("div", {
        className: "text-center py-2",
        onClick: handleSelect,
        onKeyPress: handleSelect,
        role: "button",
        tabIndex: "-1"
      }, "Select ", allOptionsAreSelected ? 'None' : 'All', /*#__PURE__*/React.createElement("hr", {
        className: "mt-1 mb-0"
      }));
    }
  }
  return null;
};
OptionActionsButtonSelectToggle.propTypes = {
  allowsMultipleSelection: PropTypes.bool.isRequired,
  setOptionsToSelect: PropTypes.func.isRequired,
  usableOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
export default OptionActionsButtonSelectToggle;